import React, { forwardRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { scientificLinkTarget } from "./audienceSites";

const ScientificLink = forwardRef(function ScientificLink({ to, ...props }, ref) {
  const { pathname } = useLocation();
  return <Link ref={ref} to={scientificLinkTarget(to, pathname)} {...props} />;
});

export default ScientificLink;
